export default "__VITE_ASSET__3f070316__"